import { Component, ElementRef, HostListener, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { Participant, Room } from '@shared/factories';
import { ChatEventsService, ChatService, NotificationService } from '@shared/services';

@Component({
  selector:      'chat-box-header',
  templateUrl: './chat-box-header.component.html',
  host: {
    class: 'am-flex-align width-min-0 gap-xs pl-xxs pr-xxs pt-xxs pb-xxs pointer animate-max-width',
    '[class.width-max-240]':     'active',
    '[class.width-max-36]':     '!active',
    '[class.am-flex-shrink-0]': '!active',
    '[class.hover-active]':     '!active',
    '[class.overflow]':         '!active || animating'
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChatBoxHeaderComponent implements OnChanges {
  @Input() room:   Room;
  @Input() active: boolean;
  menuOpen:        boolean;
  animating:       boolean;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.active && !changes.active.firstChange) this.animating = true;
    if (!this.active) this.menuOpen = false;
  }

  @HostListener('transitionend', ['$event'])
  transitionEnd(event: TransitionEvent): void {
    if (event.target === this.eRef.nativeElement && event.propertyName === 'max-width') this.animating = false;
  }

  @HostListener('document:click', ['$event'])
  outsideClick(event: Event): void {
    if (this.menuOpen && !this.eRef.nativeElement.contains(event.target)) this.menuOpen = false;
  }
  @HostListener('document:keydown.escape')
  escape(): void {
    this.menuOpen = false;
  }

  constructor(
    private eRef:                ElementRef,
    private chatEventsService:   ChatEventsService,
    private chatService:         ChatService,
    private notificationService: NotificationService,
  ) { }

  get onlineCount(): number {
    return this.room?.participants?.filter(p => p.isOnline || this.isMe(p)).length || 0;
  }

  isMe(participant: Participant): boolean {
    return !!participant && participant.id === this.room?.meAsPartisipant?.id;
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  close(): void {
    this.chatEventsService.closeRoom(this.room);
  }

  leave(): void {
    this.menuOpen = false;
    this.chatService.leaveRooom(this.room.id).subscribe();
    this.close();
  }

  readAll(): void {
    this.menuOpen = false;
    this.notificationService.wait();
    this.chatService.markAllAsRead(this.room.id).subscribe(
      () => this.notificationService.close()
    );
  }

}
